import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useLang, localized } from "../i18n/LanguageContext";
import useSEO from "../hooks/useSEO";
import api from "../lib/api";
import { Button } from "../components/ui/button";

const Pricing = () => {
  const { lang, tr, lp } = useLang();
  const [products, setProducts] = useState([]);
  useSEO({ title: `${tr.pricingPage.title} — MobiRider`, description: tr.pricingPage.subtitle, lang });
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);

  const cols = ["1", "2", "3", "4", "5", "6", "7"];

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 md:py-20">
      <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-ink tracking-tight text-center">{tr.pricingPage.title}</h1>
      <p className="text-xl text-ink-muted mt-4 text-center max-w-2xl mx-auto">{tr.pricingPage.subtitle}</p>

      <div className="mt-12 overflow-x-auto rounded-3xl border border-slate-100 shadow-md bg-white">
        <table className="w-full text-left min-w-[640px]">
          <thead>
            <tr className="bg-brand text-white">
              <th className="p-5 font-heading font-bold text-lg">{tr.flow.equipment}</th>
              {cols.map((c) => <th key={c} className="p-4 font-heading font-bold text-base text-center">{c}</th>)}
              <th className="p-4 font-heading font-bold text-base text-center">+7 /j</th>
              <th className="p-4 font-heading font-bold text-base text-center">{tr.products.deposit}</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, i) => (
              <tr key={p.id} className={i % 2 ? "bg-cream" : "bg-white"} data-testid={`price-row-${p.category}`}>
                <td className="p-4 font-semibold text-ink text-base">{localized(p.name, lang)}</td>
                {cols.map((c) => <td key={c} className="p-4 text-center text-base font-medium text-ink">{p.pricing?.tiers?.[c] ?? "-"} €</td>)}
                <td className="p-4 text-center text-base text-ink-muted">{p.pricing?.long_day} €</td>
                <td className="p-4 text-center text-ink-muted">{p.deposit?.toFixed(0)} €</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-base text-ink-muted mt-6 flex items-center gap-2"><Check className="w-5 h-5 text-brand" /> {tr.pricingPage.note}</p>
      <div className="text-center mt-10">
        <Link to={lp("/reservation")}><Button className="rounded-full h-16 px-10 bg-accent2 hover:bg-accent2-hover text-white font-bold text-xl">{tr.cta.bookNow}</Button></Link>
      </div>
    </div>
  );
};

export default Pricing;
